export const AWS_MAP_PLACES = 'https://places.geo.eu-central-1.amazonaws.com/v2'
export const MAP_STYLE = 'Standard'
export const MAP_COLOR_SCHEME = 'Light'
export const INTENDED_USE = 'Storage'
export const SEARCH_LANGUAGE = 'de-DE'
export const NAME_LAYOUT_LANGUAGE = 'de'
export const ALLOWED_COUNTRY = 'Deutschland'
export const ALLOWED_COUNTRY_CODE = 'DE'
export const GERMANY_CENTER: readonly number[] = [12.17, 51.33]
export const LATITUDE_RANGE = {
  min: 47.0,
  max: 55.99999999999999,
}
export const LATITUDE_LIMITS = {
  min: -90,
  max: 90,
}
export const LONGITUDE_RANGE = {
  min: 5.0,
  max: 16.99999999999999,
}
